module.exports = __webpack_public_path__ + "static/media/feature.96d674bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Dalyellup/feature.jpg
// module id = 231
// module chunks = 0